export { Text, PrimaryText, ProminentText, SecondaryText } from './text';
